var _filter, _filter2, _filter3, _filter4, _filter5, _radialGradient, _radialGradient2, _linearGradient, _linearGradient2, _linearGradient3, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _g4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 98 105",
    width: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 103.621,
    width: 97.8224,
    x: 0.088806,
    y: 0.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9219_7702",
    stdDeviation: 2
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 32.874,
    width: 34.2213,
    x: 14,
    y: 48.2637
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_7702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_7702",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 28.0371,
    width: 31.5329,
    x: 43.3123,
    y: 59.9873
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_7702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_7702",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 29.1172,
    width: 33.0783,
    x: 28.1938,
    y: 54.9316
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_7702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_7702",
    mode: "normal",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 61.4619,
    width: 59.8881,
    x: 16.9905,
    y: 26.1562
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_7702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_7702",
    mode: "normal",
    result: "shape"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(4.11411522 36.15850057 -34.85580573 3.96589456 50.8004 51.4939)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ffc85c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#ffc75b",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 35.4864 -49.8277 0 48.9999 52.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc85c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc536"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1784,
    x2: 59.4293,
    xlinkHref: "#h",
    y1: 24.9893,
    y2: 42.8639
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 46.9033,
    x2: 43.7759,
    xlinkHref: "#h",
    y1: 31.2223,
    y2: 60.2402
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.0617 12.853 4.6268-.3491 4.6286.2658 4.5573.8765 4.4143 1.4734 4.2015 2.0471 3.9226 2.5884 3.5817 3.0889 3.1843 3.5408 2.7369 3.9367 2.2461 4.2707 1.72 4.5372 1.1668 4.7322.5951 4.8525.014 4.8965-.5672 4.863-1.1395 4.7529-1.6939 4.5679-2.2215 4.3109-2.7141 3.9858-3.1639 3.5979-3.5638 3.1532-3.9074 2.6589-4.1896 2.1225-4.4056 1.5528-4.552.9584-4.6268.3491-4.6286-.2658-4.5574-.8765-4.4142-1.4734-4.2015-2.047-3.9226-2.5884-3.5817-3.089-3.1844-3.5408-2.7368-3.9367-2.2461-4.2707-1.72-4.5372-1.1668-4.7322-.5951-4.8525-.014-4.8964.5672-4.8631 1.1395-4.7529 1.6939-4.5679 2.2215-4.3109 2.7141-3.9858 3.1639-3.5979 3.5637-3.1532 3.9075-2.6588 4.1896-2.1226 4.4055-1.5527z",
    fill: "url(#f)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 4.5.9917 22.8858c.0982 2.265 3.294 2.6449 3.9203.466l6.279-21.84379-4.4038 22.57669c-.433 2.2199 2.5732 3.3398 3.6981 1.3777l11.1936-19.5251-9.6129 20.8811c-.9417 2.0456 1.6912 3.8456 3.2555 2.2256l15.4831-16.0345-14.3054 17.8323c-1.4015 1.7471.6889 4.1251 2.6013 2.9591l18.8943-11.5206-18.1359 13.5688c-1.7841 1.3348-.378 4.1471 1.7603 3.5208l21.1783-6.2027-20.7908 8.3562c-2.0601.828-1.4385 3.8949.7814 3.8554l22.1231-.3927-22.0493 2.5742c-2.2036.2573-2.412 3.3763-.2623 3.9245l21.6033 5.5095-21.8286-3.336c-2.198-.3359-3.2212 2.6279-1.284 3.7194l19.6269 11.0597-20.1918-8.9449c-2.0423-.9047-3.806 1.7108-2.2017 3.265l16.3494 15.8389-17.3144-13.8938c-1.7518-1.4056-4.1332.6988-2.9538 2.6102l12.0454 19.52-13.4322-17.9183c-1.354-1.8061-4.1959-.3361-3.5041 1.8126l7.0516 21.9022-8.7988-20.8383c-.8811-2.0866-4.0056-1.3318-3.8369.9269l1.7101 22.9041-3.666-22.5302c-.3642-2.2384-3.5838-2.2384-3.948 0l-3.666 22.5302 1.7101-22.9041c.1687-2.2587-2.9558-3.0135-3.8369-.9269l-8.7988 20.8383 7.0516-21.9022c.6918-2.1487-2.1501-3.6187-3.5041-1.8126l-13.4322 17.9183 12.0454-19.52c1.1794-1.9114-1.202-4.0158-2.9538-2.6102l-17.3144 13.8938 16.3494-15.8389c1.6043-1.5542-.1594-4.1697-2.2017-3.265l-20.19182 8.9449 19.62692-11.0597c1.9372-1.0915.914-4.0553-1.284-3.7194l-21.82863 3.336 21.60343-5.5095c2.1497-.5482 1.9412-3.6672-.2624-3.9245l-22.0493-2.5742 22.1231.3927c2.2199.0395 2.8415-3.0274.7814-3.8554l-20.79084-8.3562 21.17834 6.2027c2.1383.6263 3.5443-2.186 1.7603-3.5208l-18.1359-13.5688 18.8943 11.5206c1.9124 1.166 4.0028-1.212 2.6013-2.9591l-14.3054-17.8323 15.4831 16.0345c1.5643 1.62 4.1972-.18 3.2555-2.2256l-9.6129-20.8811 11.1936 19.5251c1.1249 1.9621 4.1311.8422 3.6981-1.3777l-4.4038-22.57669 6.279 21.84379c.6263 2.1789 3.8221 1.799 3.9203-.466z",
    fill: "url(#g)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.3066 66.8882c1.2422 2.6818 6.2131 2.6131 11.1027-.1535 4.8896-2.7665 7.8463-7.1833 6.6041-9.8651-.1288-.2781-.9581-2.0605-1.0894-2.3208-.5619-1.1134-3.0694-3.5118-10.7682.8443-7.8108 4.4194-7.2425 8.392-6.9163 9.1617.1156.2729.9398 2.0585 1.0671 2.3334z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2014 64.5026c-1.2422-2.6818 1.7145-7.0986 6.6041-9.8652 4.8896-2.7665 9.8605-2.8352 11.1027-.1534s-1.7146 7.0986-6.6042 9.8651c-4.8896 2.7666-9.8604 2.8353-11.1026.1535z",
    fill: "#ffc22a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.392 53.8652c.0027-.1-.1438-.1331-.3272-.0699-1.0918.3761-2.1716.8535-3.1883 1.4101-1.1196.6129-2.1406 1.3098-3.0048 2.051-.8643.7411-1.5547 1.512-2.032 2.2685-.4334.6869-.6832 1.3499-.7388 1.9577-.0093.1021.1378.1346.3212.075.1834-.0595.3336-.1887.3434-.291.0539-.5601.2852-1.1703.684-1.8025.4427-.7018 1.0832-1.4168 1.8849-2.1043.8016-.6875 1.7487-1.3339 2.7873-1.9025.9355-.5122 1.9288-.9521 2.9334-1.2997.1833-.0634.3342-.1924.3369-.2924z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.8503 64.5401c.0504.0828.2386.0792.4181-.0112 1.984-.9993 3.7039-2.2621 4.8902-3.5904.1072-.1201.0607-.2205-.0978-.2239s-.3688.0915-.4766.2116c-1.0951 1.2211-2.6759 2.3817-4.4985 3.3028-.1793.0906-.2858.2283-.2354.3111z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.273 61.5859c-3.1519 2.7566-7.5694 4.0759-9.8668 2.9467-2.2975-1.1291-1.6049-4.279 1.547-7.0356 3.1518-2.7565 7.5693-4.0758 9.8668-2.9467 2.2974 1.1291 1.6048 4.279-1.547 7.0356z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9532 57.497c3.1518-2.7565 7.5693-4.0758 9.8668-2.9467-3.595 1.2289-10.6129 7.0626-11.4138 9.9823-2.2975-1.1291-1.6049-4.279 1.547-7.0356z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.073 61.99c.3718-1.1836 1.2936-2.5072 2.7173-3.7524 3.1508-2.7556 7.5701-4.0755 9.8668-2.9467 1.0378.51 1.4662 1.4304 1.3332 2.5426.4494-1.4368.0908-2.6634-1.1703-3.2832-2.2967-1.1288-6.716.1911-9.8668 2.9467-1.7271 1.5105-2.7165 3.1415-2.8802 4.493z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8532 56.8319c.1039-.2359-.4298-.799-.7031-.6205l-2.9326 2.5712c-.2301.1503-.4652.1165-.4483-.0645l.2242-2.3989c.0272-.291-.5686-.7772-.7093-.4576l-2.8914 6.5667c-.1039.2359.2052.9456.4785.7672l3.2093-2.0954c.2302-.1503.4653-.1164.4484.0645l-.2764 1.7764c-.0272.291.5686.7772.7093.4577z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5765 56.3562c.1039-.2359-.153-.323-.4263-.1446l-3.2094 2.0954c-.2302.1503-.4652.1164-.4483-.0646l.2242-2.3988c.0272-.2911-.5165-.1547-.6572.1648l-2.8914 6.5668c-.1038.2359.153.3231.4263.1446l3.2094-2.0953c.2302-.1503.4653-.1165.4483.0645l-.2241 2.3988c-.0272.2911.5164.1548.6571-.1648z",
    fill: "#ffdd28"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2701 38.8068c1.8449 2.0799.7707 6.325-2.3994 9.4818-3.17 3.1568-7.2355 4.0299-9.0804 1.95-.1913-.2157-.7598-.8605-.9365-1.0716-.7566-.9032-2.1198-3.9632 2.8715-8.9337 5.064-5.0427 8.058-3.0545 8.5938-2.4837.1899.2024.7619.844.951 1.0572z",
    fill: "#f19018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.1212 37.5122c-1.845-2.0799-5.9104-1.2069-9.0805 1.9499-3.17 3.1568-4.2442 7.402-2.3993 9.4819s5.9104 1.2069 9.0805-1.9499c3.17-3.1568 4.2442-7.402 2.3993-9.4819z",
    fill: "#ffc32d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.1542 47.642c2.8055-1.6674 4.7454-4.965 4.3329-7.3653-.4125-2.4004-3.0212-2.9945-5.8267-1.3271s-4.7454 4.965-4.3329 7.3654c.4125 2.4003 3.0212 2.9944 5.8267 1.327z",
    fill: "#f39e09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.6604 38.9496c-2.8055 1.6674-4.7454 4.965-4.3329 7.3654 1.5206-1.5143 5.7697-5.7456 10.1596-6.0383-.4125-2.4004-3.0212-2.9945-5.8267-1.3271z",
    fill: "#ffaa16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32.7698 38.1711c-1.0032-.1273-2.2288.165-3.4961.9182-2.8046 1.6669-4.7452 4.9658-4.3329 7.3653.1864 1.0843.8191 1.7999 1.7173 2.1056-1.2173-.1564-2.1042-.9277-2.3306-2.2452-.4124-2.3996 1.5283-5.6985 4.3329-7.3654 1.5373-.9137 3.0175-1.148 4.1094-.7785z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2479 41.0474c-.0788-.0414-.0639-.1738.0365-.2939.5974-.7152 1.2705-1.3766 1.9878-1.9526.79-.6343 1.6182-1.1527 2.4373-1.5256.819-.3729 1.613-.5929 2.3364-.6475.6569-.0495 1.244.0381 1.734.2583.0823.037.0668.1696-.0307.2913s-.2402.1863-.3227.1497c-.4524-.2007-.9932-.2804-1.5977-.2348-.6711.0507-1.4075.2548-2.1673.6006-.7597.3459-1.528.8268-2.2608 1.4152-.6601.5301-1.2799 1.1381-1.8307 1.7954-.1006.12-.2433.1853-.3221.1439z",
    fill: "#ffe77e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m31.9362 46.8094c.0506.0766-.0045.2265-.125.3317-1.3321 1.1619-2.7965 1.9965-4.1636 2.3727-.1237.034-.1891-.0472-.1477-.1763.0415-.1291.1741-.2571.2978-.2915 1.2581-.3496 2.604-1.1166 3.8302-2.1827.1206-.1049.2577-.1306.3083-.0539z",
    fill: "#ffe77e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8014 46.1388c-.2058.0379-.5239-.5516-.3252-.7495l2.6419-1.978c.1674-.1667.1933-.3787.0493-.4043l-1.9085-.3391c-.2316-.0411-.4764-.6675-.1976-.7187l5.8922-1.2153c.2058-.0379.5239.5516.3251.7495l-2.3343 2.3247c-.1675.1667-.1933.3786-.0493.4042l1.601-.0075c.2316.0411.313.8302.0343.8814z",
    fill: "#e88711"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m26.4937 45.7924c-.2058.0378-.2164-.205-.0176-.403l2.3343-2.3246c.1675-.1667.1933-.3787.0493-.4043l-1.9085-.339c-.2316-.0412-.0055-.4836.2733-.5348l5.7288-1.0527c.2058-.0378.2165.205.0177.403l-2.3344 2.3246c-.1674.1667-.1933.3787-.0493.4042l1.9085.3391c.2316.0412.0056.4836-.2732.5348z",
    fill: "#ffdd28"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.0239 69.3496c-.474 3.4945 3.3711 6.9712 8.5882 7.7656 5.2171.7943 9.8306-1.3946 10.3045-4.8891.0492-.3623.1926-1.443.2303-1.7897.1614-1.4838-.4848-5.6044-8.6993-6.8551-8.3339-1.2689-10.0104 3.0009-10.1697 3.9822-.0565.3479-.2055 1.428-.254 1.7861z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.319 67.1742c.4739-3.4945 5.0874-5.6834 10.3045-4.8891 5.2171.7944 9.0622 4.2711 8.5883 7.7656-.474 3.4944-5.0874 5.6833-10.3045 4.889s-9.0622-4.2711-8.5883-7.7655z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.8833 73.6548c-3.8803.4348-7.9663-1.4309-9.1263-4.1671-1.1601-2.7362 1.0452-5.3068 4.9255-5.7415 3.8803-.4348 7.9663 1.4309 9.1263 4.1671 1.1601 2.7362-1.0452 5.3068-4.9255 5.7415z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.6825 63.7462c3.8803-.4348 7.9663 1.4309 9.1263 4.1671-2.5025-.381-9.4954-1.4457-14.0518 1.5744-1.1601-2.7362 1.0452-5.3068 4.9255-5.7415z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.0872 66.0638c.9141-.8864 2.324-1.5169 4.0768-1.7133 3.8791-.4346 7.9667 1.4319 9.1264 4.1672.524 1.2359.3629 2.4367-.3303 3.4239 1.1082-1.0774 1.4855-2.5264.8487-4.0283-1.1596-2.7353-5.2472-4.6017-9.1263-4.1671-2.1263.2382-3.7514 1.1195-4.5953 2.3176z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.4493 63.2868c.0512-.1013-.0502-.2238-.2285-.2693-1.0619-.2712-2.1638-.4308-3.2539-.4709-1.2005-.044-2.3631.0579-3.4214.2999s-1.9917.6195-2.7467 1.1108c-.6856.4461-1.2121.9781-1.5553 1.5706-.0576.0995.0446.2218.2212.271.1765.0493.3606.0068.4188-.0925.3185-.5444.8041-1.0334 1.435-1.4439.7004-.4557 1.5662-.8058 2.5479-1.0304.9817-.2245 2.0601-.319 3.1737-.2781 1.0031.0368 2.0171.1829 2.9948.4308.1785.0452.3631.0034.4144-.098z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.5676 74.1588c-.0002.1156.1527.2254.3413.2406 2.0847.1675 4.0867-.0956 5.6921-.7481.1453-.059.1572-.1905.0315-.2896-.1256-.0991-.3412-.1283-.4867-.0695-1.4797.5971-3.3197.8389-5.2363.6882-.1885-.0149-.3417.0627-.3419.1784z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.4326 69.1089c.2294-.1173.1601-.953-.167-1.0028l-3.9208-.0025c-.2756-.042-.4399-.2366-.3134-.3712l1.6758-1.784c.2034-.2165.037-1.0341-.2737-.8753l-6.9226 3.182c-.2294.1173.1087.9939.4359 1.0437l3.8418.5849c.2755.042.4398.2366.3134.3712l-1.8657 1.1607c-.2034.2165.5006 1.1159.8113.9571z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.5118 68.5266c.2294-.1173.0811-.3706-.246-.4204l-3.8418-.5849c-.2755-.042-.4399-.2365-.3134-.3711l1.6758-1.7841c.2034-.2165-.3108-.4926-.6215-.3338l-6.385 3.2638c-.2293.1173-.0811.3706.2461.4204l3.8418.5849c.2755.042.4398.2366.3134.3712l-1.6759 1.784c-.2033.2165.3108.4926.6215.3338z",
    fill: "#ffdd28"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.3135 67.9122c.5199 3.6391 5.4342 5.8686 10.9764 4.9798s9.6136-4.5594 9.0937-8.1986c-.0539-.3773-.2179-1.5017-.279-1.8598-.2612-1.5324-2.1018-5.4353-10.8282-4.0358-8.8532 1.4199-9.3359 6.2201-9.2166 7.2505.0423.3652.2004 1.4909.2537 1.8639z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.9899 65.6461c-.5198-3.6391 3.5516-7.3098 9.0938-8.1986s10.4565 1.3408 10.9763 4.9799c.5199 3.6391-3.5515 7.3097-9.0937 8.1986-5.5422.8888-10.4565-1.3408-10.9764-4.9799z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.6282 68.3765c-3.8279 1.6843-8.5253 1.1397-10.492-1.2163-1.9667-2.3561-.4579-5.6314 3.37-7.3157 3.8279-1.6842 8.5253-1.1396 10.492 1.2164 1.9667 2.3561.4579 5.6314-3.37 7.3156z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.5062 59.8445c3.8279-1.6842 8.5253-1.1396 10.492 1.2164-2.6585.4264-10.0871 1.6177-13.862 6.0993-1.9667-2.3561-.4579-5.6314 3.37-7.3157z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4902 63.6377c.6769-1.1789 1.9322-2.2623 3.6613-3.0231 3.8266-1.6837 8.5259-1.1389 10.492 1.2164.8883 1.0642 1.0688 2.3141.646 3.5224.8196-1.432.7883-2.9992-.2913-4.2925-1.966-2.3553-6.6654-2.9001-10.492-1.2164-2.0975.923-3.5001 2.326-4.016 3.7932z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.2301 57.8496c.0231-.1177-.1153-.2072-.3101-.1951-1.1594.0716-2.3277.2675-3.4495.5788-1.2355.343-2.3905.8193-3.3992 1.4018-1.0086.5826-1.851 1.2599-2.4792 1.9934-.5703.666-.9539 1.3665-1.1335 2.0682-.0302.1179.109.207.303.1992s.3693-.1095.4-.2273c.1683-.6458.5226-1.2902 1.0475-1.9031.5827-.6804 1.3642-1.3087 2.2997-1.849.9356-.5404 2.007-.9822 3.153-1.3003 1.0325-.2866 2.1072-.4676 3.1743-.5354.1948-.0123.3708-.1136.394-.2312z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4139 69.6251c.033.1154.2203.1757.4167.1301 2.1716-.5047 4.1354-1.4124 5.5836-2.5808.131-.1057.1054-.2408-.051-.2991-.1564-.0584-.3844-.018-.5158.0875-1.3359 1.0726-3.1408 1.9068-5.1364 2.3741-.1963.046-.3301.1728-.2971.2882z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.8617 63.5766c.2-.1909-.1103-1.0023-.4578-.9466l-3.9946 1.261c-.2927.047-.5159-.0942-.4257-.2692l1.1952-2.3201c.145-.2815-.2591-1.0436-.53-.785l-5.853 5.3598c-.2.1909.1103 1.0023.4578.9466l4.0812-.6545c.2927-.047.516.0942.4258.2693l-1.2819 1.7135c-.145.2815.5446.9978.8155.7392z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.775 62.9696c.2-.1909-.0237-.3958-.3712-.3401l-4.0812.6546c-.2927.0469-.516-.0943-.4258-.2693l1.1952-2.32c.1451-.2815-.4579-.3914-.7288-.1328l-5.5675 5.314c-.2.1909.0237.3959.3712.3401l4.0812-.6545c.2927-.0469.5159.0943.4258.2693l-1.1953 2.32c-.145.2815.458.3913.7289.1328z",
    fill: "#ffdd28"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m47.1602 36.7258c1.185 5.0219 5.6387 8.067 9.9477 6.8015 4.3089-1.2655 6.0872-2.1929 4.031-10.907-2.0116-8.5246-4.0133-8.5444-8.3223-7.2789-4.3089 1.2655-6.8414 6.3625-5.6564 11.3844z",
    fill: "#f19018"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m58.4623 43.148c4.3015-1.2637 6.8296-6.353 5.6466-11.3674s-5.629-8.0549-9.9305-6.7913c-4.3016 1.2637-6.8297 6.353-5.6467 11.3674 1.183 5.0143 5.6291 8.0549 9.9306 6.7913z",
    fill: "url(#i)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m50.9798 33.1336c-.3388 3.6903 1.8246 7.0844 4.8319 7.5809 3.0074.4966 5.72-2.0924 6.0587-5.7827.3388-3.6902-1.8246-7.0843-4.832-7.5809-3.0073-.4966-5.7199 2.0925-6.0586 5.7827z",
    fill: "#f39e09"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m56.6236 27.9566c-3.0181-.4984-4.3887 1.3712-4.9469 2.5129 1.8497.6044 6.812 4.1502 8.5902 8.1717 2.8407-5.0793-.6253-10.1863-3.6433-10.6846z",
    fill: "#ffaa16"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m59.514 39.7139c.9301-1.0353 1.5657-2.4762 1.7187-4.1431.3386-3.6891-1.8256-7.0845-4.832-7.5809-1.3585-.2243-2.6553.1792-3.7023 1.0309 1.1306-1.2556 2.6892-1.9122 4.34-1.6396 3.0064.4964 5.1707 3.8918 4.832 7.5809-.1856 2.0221-1.0859 3.7156-2.3564 4.7518z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m59.5665 34.303c.2282-.1555.194-.5539-.0569-.6611l-2.9461-1.2591c-.2113-.0903-.2789-.4012-.129-.593l1.9872-2.5423c.2411-.3085-.7693-1.0694-1.0785-.8588l-5.6705 4.6219c-.2283.1555-.1908.9144.06 1.0217l2.9429.8985c.2113.0903.279.4012.129.593l-1.7956 2.8194c-.2412.3085.8295.8707 1.1387.66z",
    fill: "#e88711"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m60.0694 34.03c.2162-.1785.1505-.5734-.1091-.6554l-3.0481-.9628c-.2186-.0691-.3109-.3732-.1759-.58l1.7883-2.7417c.217-.3327-.1464-.7684-.4393-.5266l-6.0188 4.9674c-.2163.1785-.1505.5734.109.6554l3.0482.9628c.2186.0691.3109.3732.1759.58l-1.7884 2.7417c-.217.3327.1465.7684.4394.5267z",
    fill: "#ffd83b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m52.7586 26.6052c-.0677-.1526-.0148-.3363.1208-.4042.8074-.4042 1.6759-.6405 2.5646-.6971.9787-.0622 1.9628.0948 2.8961.4622s1.7976.9379 2.5434 1.679c.6772.673 1.2448 1.4746 1.6764 2.3666.0725.1498.019.3333-.1143.4067-.1332.0735-.2956.009-.3685-.1405-.3992-.8196-.9223-1.5563-1.5455-2.1756-.6918-.6875-1.4935-1.2167-2.3592-1.5575-.8658-.3408-1.7786-.4865-2.6865-.4287-.8178.052-1.6172.2682-2.3611.6377-.1358.0675-.2985.0039-.3662-.1486z",
    fill: "#ffe77e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m57.7456 42.2544c.0278.1666-.0685.3248-.216.3466-1.6309.2413-3.2986-.1377-4.7415-1.0777-.1305-.085-.1715-.2744-.0945-.4171.0771-.1428.2429-.1847.3736-.1001 1.3288.86 2.8615 1.2084 4.3617.9913.1476-.0213.2889.0905.3167.257z",
    fill: "#ffe77e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.8302 47.3537c-.61 8.0497-6.825 13.9588-13.8816 13.1983-7.0565-.7604-10.0691-1.6973-9.0107-15.6653 1.0355-13.6642 4.1631-14.2456 11.2197-13.4851 7.0566.7604 12.2826 7.9025 11.6726 15.9521z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.697 60.3395c-7.0479-.7596-12.2674-7.8935-11.6582-15.934.6093-8.0405 6.8166-13.9428 13.8645-13.1832 7.048.7596 12.2675 7.8935 11.6583 15.934-.6093 8.0405-6.8167 13.9428-13.8646 13.1832z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.0575 42.7937c1.4136 5.5191-1.2161 11.3124-5.8738 12.9397-4.6576 1.6273-9.5794-1.5276-10.9931-7.0468-1.4137-5.5191 1.2161-11.3124 5.8737-12.9397 4.6577-1.6273 9.5795 1.5277 10.9932 7.0468z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.849 36.5546c4.6649-1.6302 7.2799.814 8.4348 2.3874-2.7882 1.4533-9.8126 8.2764-11.6781 14.9013-5.7049-6.8961-1.4215-15.6586 3.2433-17.2887z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.0601 55.2633c-1.7225-1.3063-3.0737-3.3155-3.7123-5.8085-1.4133-5.5174 1.2175-11.313 5.8737-12.9398 2.1039-.735 4.2589-.4966 6.1236.4965-2.0933-1.5837-4.7241-2.1315-7.2808-1.2382-4.6561 1.6267-7.2869 7.4224-5.8737 12.9397.7747 3.0243 2.6061 5.3412 4.8695 6.5503z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.6261 44.7285c.3057-.3407.1155-.9221-.3155-.9649l-5.0621-.502c-.3631-.036-.5758-.4705-.4057-.8288l2.2543-4.7483c.2736-.5761-1.5752-1.2419-1.9892-.7804l-7.3332 9.6007c-.3057.3407-.1155.9221.3155.9648l5.0621.502c.3631.0361.5758.4706.4057.8288l-3.4567 4.9581c-.2736.5762 1.6018.9156 2.0159.4541z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.3602 44.6073c.3057-.3408.1156-.9221-.3155-.9649l-5.062-.502c-.363-.036-.5757-.4705-.4056-.8287l2.2542-4.7483c.2736-.5761-.3994-1.1253-.8135-.6638l-8.5087 9.4839c-.3056.3408-.1155.9221.3155.9649l5.062.502c.363.036.5757.4705.4057.8287l-2.2543 4.7483c-.2735.5761.3995 1.1253.8135.6638z",
    fill: "#ffd83b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe77e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.486 33.3647c.0684-.2535-.0605-.5215-.2906-.5884-1.3701-.3982-2.7943-.5213-4.2056-.3621-1.5543.1753-3.0624.6895-4.4382 1.5133-1.3758.8237-2.5925 1.9409-3.5805 3.2877-.8971 1.2229-1.5897 2.6134-2.0463 4.1053-.0766.2505.0533.518.281.5941.2278.0761.4671-.068.5444-.3183.4236-1.3714 1.0625-2.6499 1.8881-3.7753.9164-1.2493 2.045-2.2855 3.3212-3.0496 1.2762-.7642 2.6751-1.2411 4.1168-1.4038 1.2988-.1465 2.6094-.0352 3.871.3272.2302.0662.4702-.0767.5387-.3301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6624 58.7017c-.0022.2642.1888.4811.4264.4739 2.6265-.0801 5.156-1.1258 7.1919-2.973.1842-.1671.2014-.4702.0446-.6686-.1568-.1985-.4282-.2172-.6127-.0507-1.8763 1.6926-4.2012 2.6536-6.616 2.7348-.2375.008-.4321.2194-.4342.4836z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m60.9815 48.0436c-2.2167 2.4989-.926 7.5994 2.8827 11.3922s8.6933 4.8417 10.9099 2.3427c.2299-.2591.9128-1.0338 1.1252-1.2874.909-1.0852 2.5469-4.7617-3.4501-10.7336-6.0842-6.0587-9.6814-3.6699-10.3251-2.9841-.2282.2432-.9154 1.0141-1.1426 1.2702z",
    fill: "#f19018"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m62.3612 46.4874c2.2167-2.4989 7.1012-1.45 10.9099 2.3428s5.0994 8.8932 2.8827 11.3922c-2.2166 2.4989-7.1011 1.45-10.9099-2.3428-3.8087-3.7928-5.0993-8.8933-2.8827-11.3922z",
    fill: "#ffc32d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m68.3284 58.6581c-3.3708-2.0034-5.7015-5.9654-5.2059-8.8493s3.6299-3.5978 7.0006-1.5944c3.3707 2.0033 5.7015 5.9653 5.2059 8.8492-.4957 2.884-3.6299 3.5978-7.0006 1.5945z",
    fill: "#f39e09"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m70.1231 48.2144c3.3707 2.0033 5.7015 5.9653 5.2059 8.8492-1.827-1.8193-6.9321-6.9031-12.2065-7.2548.4957-2.8839 3.6299-3.5978 7.0006-1.5944z",
    fill: "#ffaa16"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m65.1858 47.2791c1.2052-.153 2.6778.1982 4.2004 1.1031 3.3696 2.0027 5.7013 5.9663 5.2058 8.8493-.2238 1.3027-.984 2.1624-2.0632 2.5297 1.4625-.1879 2.5281-1.1145 2.8002-2.6976.4954-2.883-1.8363-6.8465-5.2059-8.8492-1.847-1.0978-3.6254-1.3793-4.9373-.9353z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m74.2242 50.7358c.0947-.0498.0767-.2088-.0438-.3531-.7178-.8593-1.5265-1.6539-2.3884-2.346-.9491-.7621-1.9442-1.385-2.9283-1.833-.984-.4479-1.9379-.7123-2.8071-.7779-.7893-.0595-1.4947.0458-2.0834.3103-.0989.0445-.0803.2038.0369.35s.2886.2239.3878.1799c.5435-.2411 1.1932-.3369 1.9195-.2821.8063.0609 1.6911.3061 2.604.7216.9128.4155 1.8358.9933 2.7162 1.7003.7932.6368 1.5378 1.3674 2.1996 2.1572.1208.1441.2923.2225.387.1728z",
    fill: "#ffe77e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m66.1876 57.6581c-.0608.0921.0055.2723.1502.3985 1.6005 1.3961 3.36 2.3988 5.0025 2.8508.1486.0409.2272-.0567.1774-.2118s-.2091-.3089-.3578-.3502c-1.5115-.42-3.1286-1.3416-4.6018-2.6225-.1449-.126-.3097-.1569-.3705-.0648z",
    fill: "#ffe77e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m72.358 56.8517c.2473.0455.6295-.6627.3907-.9006l-3.1741-2.3764c-.2012-.2004-.2322-.455-.0592-.4857l2.293-.4074c.2782-.0495.5723-.8021.2374-.8636l-7.0793-1.4602c-.2473-.0454-.6295.6628-.3907.9006l2.8047 2.793c.2011.2003.2322.455.0592.4857l-1.9236-.0091c-.2782.0495-.3761.9975-.0411 1.059z",
    fill: "#e88711"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m72.7272 56.4347c.2473.0455.2601-.2463.0212-.4841l-2.8047-2.793c-.2011-.2003-.2322-.4549-.0592-.4857l2.293-.4074c.2783-.0494.0067-.581-.3282-.6425l-6.8831-1.2647c-.2473-.0455-.2601.2463-.0212.4841l2.8047 2.793c.2011.2003.2321.4549.0591.4857l-2.293.4074c-.2782.0494-.0066.581.3283.6425z",
    fill: "#ffdd28"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.4046 21.7178.351 4.327 3.6018-2.4235-3.1642 2.9723 4.1405 1.305-4.2967-.6206 1.5612 4.0508-2.1936-3.7463-2.1937 3.7463 1.5612-4.0508-4.2966.6206 4.1404-1.305-3.1641-2.9723 3.6018 2.4235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.212 59.626.2382 2.9362 2.4441-1.6445-2.1471 2.0169 2.8095.8855-2.9155-.4211 1.0593 2.7487-1.4885-2.5421-1.4885 2.5421 1.0593-2.7487-2.9155.4211 2.8095-.8855-2.1471-2.0169 2.4441 1.6445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.8762 33.4307.2381 2.9362 2.4441-1.6445-2.1471 2.0169 2.8096.8855-2.9156-.4211 1.0594 2.7487-1.4885-2.5421-1.4886 2.5421 1.0594-2.7487-2.9155.4211 2.8095-.8855-2.1471-2.0169 2.4441 1.6445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins03);
export default __webpack_public_path__ + "static/media/coins-03.3ed98d2fd5056b220b9e58393a45dced.svg";
export { ForwardRef as ReactComponent };